import { useRef, useState } from 'react';
import './../../App.css';
import emailjs from '@emailjs/browser';
import inputData from './../../modules/inputData/inputData'
import Request_1 from './Form/Request_1';
import Request_2 from './Form/Request_2';
import Request_3 from './Form/Request_3';
import Request_4 from './Form/Request_4';
import Request_5 from './Form/Request_5';
import Request_6 from './Form/Request_6';
import Request_7 from './Form/Request_7';
import Request_8 from './Form/Request_8';
import Law from './../Law';
import { useNavigate } from 'react-router-dom';



export default function Intro(){
    const navigate = useNavigate();

    // Change Object
    let [dataObj, setDataObj] = useState({});

    // Choose subjects
    const [checkItems, setCheckItems] = useState([]);
    const selectChecked = (checked, value) => {
        if (checked) {
          setCheckItems(item => [...item, value]); 
        } else {
          setCheckItems(checkItems.filter((el) => el !== value));
        }
    };
    const requiredItems = [
        'request_1',
        'request_2',
        'request_3',
        'request_4',
        'request_5',
        'request_6',
        'request_7',
        'request_8',
    ];



    // Email-JS
    const form = useRef();
    const sendEmail = e => {
        e.preventDefault();

        const hasRequiredItem = checkItems.some(item => requiredItems.includes(item));
        if (hasRequiredItem) {
            emailjs.sendForm(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATE_ID, form.current, process.env.REACT_APP_SECRET_KEY).then(
            result => {
                alert("의뢰서 전송이 완료되었습니다. 다음 단계를 진행해주세요.");
                form.current.reset();
                navigate('/upload')
                window.location.reload()
    
            },
            error => {
                console.log(error);
                alert("이메일이 전송이 실패되었습니다.");
            },
            );
        } else {
            alert('의뢰종류를 체크해주세요.');
        }

    };



    return(
        <>
            <div className='intro'>
                <form className='form' ref={form} onSubmit={sendEmail}>
                    {/* require 사용해서 빈칸 없애기 */}
                    <div className='form-header'>
                        <ul className='form-header__logo'>
                            <li style={{color:'red'}}>
                                <img src='/images/logo.png' />
                            </li>
                            <li>가설 구조물 도면 설계 전문회사<br/>JH시스템</li>
                        </ul>
                        <ul>
                            <li>의뢰 가능 종류 : 도면 설계, 견적용 물량도, 구조검토, 기성도면</li>
                        </ul>
                        <ul>
                            <li>의뢰 접수 시스템</li>
                        </ul>
                        <ul>
                            <li>업체명 (의뢰하는 회사)</li>
                            <li>
                                <label>
                                    <input
                                        type="text"
                                        name="업체명"
                                        placeholder="의뢰하는 회사명을 입력해주세요"
                                        required
                                    />
                                </label>
                            </li>
                        </ul>
                        <ul>
                            <li>담당자 (의뢰자) 성함</li>
                            <li>
                                <label>
                                    <input
                                        type="text"
                                        name="담당자"
                                        placeholder="의뢰자 성함을 입력해주세요"
                                        required
                                    />
                                </label>
                            </li>
                        </ul>
                        <ul>
                            <li>연락처</li>
                            <li>
                                <label>
                                    <input
                                        type="text"
                                        name="연락처"
                                        placeholder="공란을 채워주세요"
                                        required
                                    />
                                </label>
                            </li>
                        </ul>
                        <ul>
                            <li>현장명</li>
                            <li>
                                <label>
                                    <input
                                        type="text"
                                        name="현장명"
                                        placeholder="공란을 채워주세요"
                                        required
                                    />
                                </label>
                            </li>
                        </ul>
                        <ul>
                            <li>ID(보내는 사람 메일주소)</li>
                            <li>
                                <label>
                                    <input
                                        type="text"
                                        name="user_email"
                                        placeholder="공란을 채워주세요"
                                        required
                                    />
                                </label>
                            </li>
                        </ul>
                        <ul className='form-law'>
                            <li>개인정보처리방침</li>
                            <li>
                                <label>
                                    <input
                                    type="checkbox"
                                    name="?"
                                    onChange={(e)=>{inputData(setDataObj, '개인정보', e.target.value)}}
                                    style={{width:"auto"}}
                                    required
                                    /> 동의
                                </label>
                                {/* <span>[약관보기]</span> */}
                                <Law />
                            </li>
                        </ul>
                        <ul className='form-header__request'>
                            <li>의뢰종류</li>
                            <div>
                                <ul>
                                    <li>도면설계</li>
                                    <div>
                                        <li>
                                            <label>
                                                <input
                                                type="checkbox" name="의뢰종류_1" onChange={(e) => selectChecked(e.target.checked, 'request_1')}
                                                /> 동바리
                                            </label>
                                        </li>
                                        <li>
                                            <label>
                                                <input type="checkbox" name="의뢰종류_2" onChange={(e) => selectChecked(e.target.checked, 'request_2')} /> 비계
                                            </label>
                                        </li>
                                        <li>
                                            <label>
                                                <input type="checkbox" name="의뢰종류_3" onChange={(e) => selectChecked(e.target.checked, 'request_3')} /> 유로폼 (거푸집)
                                            </label>
                                        </li>
                                        <li>
                                            <label>
                                                <input type="checkbox" name="의뢰종류_4" onChange={(e) => selectChecked(e.target.checked, 'request_4')} /> RPP 방음벽 (파이프 타입)
                                            </label>
                                        </li>
                                        <li>
                                            <label>
                                                <input type="checkbox" name="의뢰종류_5" onChange={(e) => selectChecked(e.target.checked, 'request_5')} /> 달비계(공중비계)
                                            </label>
                                        </li>
                                    </div>
                                </ul>
                                <li>
                                    <label>
                                        <input type="checkbox" name="의뢰종류_6" onChange={(e) => selectChecked(e.target.checked, 'request_6')} /> 구조 검토
                                    </label>
                                </li>
                                <li>
                                    <label>
                                        <input type="checkbox" name="의뢰종류_7" onChange={(e) => selectChecked(e.target.checked, 'request_7')} /> AUTOJH 도면 자동화 설계 프로그램 임대 문의, 데모프로그램 신청
                                    </label>
                                </li>
                                <li>
                                    <label>
                                        <input type="checkbox" name="의뢰종류_8" onChange={(e) => selectChecked(e.target.checked, 'request_8')} /> 견적 문의 (견적서 신청)
                                    </label>
                                </li>
                            </div>
                        </ul>
                    </div>

                    <input type="hidden" name="선택내용" value={checkItems.map(item => {
                        const labels = {
                            'request_1': '동바리',
                            'request_2': '비계',
                            'request_3': '유로폼',
                            'request_4': 'RPP 방음벽',
                            'request_5': '달비계',
                            'request_6': '구조 검토',
                            'request_7': '데모신청',
                            'request_8': '견적 문의',
                        };
                        return labels[item] || item;
                    }).join(', ')} />

                    {checkItems.includes('request_1') ? <Request_1 checkItems={checkItems} /> : ''}
                    {checkItems.includes('request_2') ? <Request_2 checkItems={checkItems} /> : ''}
                    {checkItems.includes('request_3') ? <Request_3 /> : ''}
                    {checkItems.includes('request_4') ? <Request_4 /> : ''}
                    {checkItems.includes('request_5') ? <Request_5 /> : ''}
                    {checkItems.includes('request_6') ? <Request_6 checkItems={checkItems} /> : ''}
                    {checkItems.includes('request_7') ? <Request_7 /> : ''}
                    {checkItems.includes('request_8') ? <Request_8 checkItems={checkItems} /> : ''}


                    <div className='form-header form-submit'>
                        <input type="submit" value="전송하기" />
                    </div>

                    <div className='form-header'>
                        <ul>
                            <li>회사 대표 연락처</li>
                            <li>010-5762-1829</li>
                        </ul>
                        <ul>
                            <li>회사 대표 이메일 주소</li>
                            <li>jhsystem@jhsystem.by-works.com</li>
                        </ul>
                        <ul>
                            <li>회사 홈페이지 주소</li>
                            <li><a href='https://jhsystem.clickn.co.kr' target='_blank'>https://jhsystem.clickn.co.kr</a></li>
                        </ul>
                    </div>
                </form>
            </div>
        </>
    )
}